import { Controller } from "@hotwired/stimulus"

// Keeps .main-wrapper scroll across dashboard date frame visits only.
// Pending position is module-level so replacing #dashboard_as_of still
// restores. Ignores nested map frame loads. Copies the current map layer
// and sanitation form onto as-of links so week/day paging does not reset
// them. The form id comes from the combobox hidden field, not the visible
// input (that one holds the form name).
let pendingScrollTop = null

export default class extends Controller {
  connect() {
    this.restore()
  }

  save(event) {
    const link = event.target.closest("a[data-turbo-frame='dashboard_as_of']")
    if (!link) return

    this.#preserveQueryParam(link, "layer", this.#currentMapLayer())
    this.#preserveQueryParam(link, "sanitation_form_id", this.#currentSanitationFormId())

    const container = this.#scrollContainer
    if (!container) return

    pendingScrollTop = container.scrollTop
  }

  restore() {
    if (pendingScrollTop == null) return

    const container = this.#scrollContainer
    if (!container) return

    container.scrollTop = pendingScrollTop
  }

  finish(event) {
    if (event?.target?.id && event.target.id !== "dashboard_as_of") return

    this.restore()
    pendingScrollTop = null
  }

  #preserveQueryParam(link, name, value) {
    if (!value) return

    const url = new URL(link.getAttribute("href"), window.location.origin)
    url.searchParams.set(name, value)
    link.setAttribute("href", `${url.pathname}${url.search}`)
  }

  #currentSanitationFormId() {
    const hidden = document.querySelector("input[name='sanitation_form_id']")
    return this.#numericId(hidden?.value)
      || this.#numericId(this.#paramFromMapOrLocation("sanitation_form_id"))
  }

  #currentMapLayer() {
    const mapEl = document.querySelector("[data-dashboard--map-layer-value]")
    return mapEl?.getAttribute("data-dashboard--map-layer-value")
      || this.#paramFromMapOrLocation("layer")
  }

  #paramFromMapOrLocation(name) {
    const mapFrame = document.querySelector("turbo-frame#dashboard_map")
    return this.#paramFromSrc(mapFrame?.getAttribute("src"), name)
      || new URL(window.location.href).searchParams.get(name)
  }

  #paramFromSrc(src, name) {
    if (!src) return null

    return new URL(src, window.location.origin).searchParams.get(name)
  }

  #numericId(value) {
    if (!value) return null
    if (!/^\d+$/.test(String(value))) return null

    return String(value)
  }

  get #scrollContainer() {
    let el = this.element.parentElement
    while (el) {
      const { overflow, overflowY } = getComputedStyle(el)
      if (overflow === "auto" || overflow === "scroll" ||
          overflowY === "auto" || overflowY === "scroll") {
        return el
      }
      el = el.parentElement
    }
    return null
  }
}
